export default {
    additionalInformation: 'Additional Information',
    editTeamMemberInfo: 'Edit Team Member Info',
    keyValues: {
        createdBy: 'Created By',
        dateCreated: 'Date Created',
        endDate: 'End Date',
        license: 'License',
        senderSignature: 'Sender Signature',
        startDate: 'Start Date',
    },
    resendInvitation: 'Resend Invitation',
    revoke: 'Revoke Access',
};
